import { h } from 'vue'
import type { ColumnDef } from "@tanstack/vue-table"
import { Badge } from "@/components/ui/badge"
import DropdownAction from './data-table-dropdown.vue'

// Define the Product interface based on the model structure
export interface Product {
  id: string
  name: string
  description?: string
  meta?: Record<string, any>
  sku: string
  price: number
  unit_quantity: number
  unit_id?: number
  unit?: ProductUnit
  color?: string
  is_service_fee: boolean
  is_active: boolean
  sort_order: number
  currency?: string
}

// Define the ProductUnit interface based on the model structure
export interface ProductUnit {
  id: string
  name: string
  abbreviation: string
  measurement_type: string
  base_ratio: number
}

export const columns: ColumnDef<Product>[] = [
  {
    accessorKey: "sku",
    header: () => h('div', {}, "Артикул"),
    cell: ({ row }) => h('div', { class: "font-medium" }, row.getValue("sku")),
  },
  {
    accessorKey: "name",
    header: () => h('div', {}, "Название"),
    cell: ({ row }) => {
      const product = row.original
      const colorStyle = product.color ? 
        { backgroundColor: `#${product.color}`, width: '12px', height: '12px', display: 'inline-block', marginRight: '8px', borderRadius: '2px' } : {}
      
      return h("div", { class: "flex items-center" }, [
        product.color && h("div", { style: colorStyle }),
        h("span", {}, product.name),
      ])
    },
  },
  {
    accessorKey: "price",
    header: () => h('div', {}, "Цена"),
    cell: ({ row }) => {
      const price = parseFloat(row.getValue("price")).toFixed(2)
      const currency = row.original.currency
      // const formatted = new Intl.NumberFormat("ru-RU", {
      //   style: "currency",
      //   currency: currency,
      // }).format(price)

      return h("div", { class: "font-medium" }, `${price} ${currency}`)
    },
  },
  {
    accessorKey: "unit_quantity",
    header: () => h('div', {}, "Ед. измерения"),
    cell: ({ row }) => {
      const quantity = parseFloat(row.getValue("unit_quantity"))
      const unit = row.original.unit?.abbreviation || ""

      return h("div", {}, `${quantity} ${unit}`)
    },
  },
  {
    accessorKey: "is_active",
    header: () => h('div', {}, "Статус"),
    cell: ({ row }) => {
      const isActive = row.getValue("is_active")

      return h(Badge, {
        variant: isActive ? "success" : "outline",
      }, () => isActive ? "Активный" : "Неактивный")
    },
  },
  {
    accessorKey: "is_service_fee",
    header: () => h('div', {}, "Тип"),
    cell: ({ row }) => {
      const isServiceFee = row.getValue("is_service_fee")

      return h(Badge, {
        variant: "outline",
      }, () => isServiceFee ? "Сервисный сбор" : "Продукт")
    },
  },
  {
    id: 'actions',
    enableHiding: false,
    cell: ({ row }) => {
      return h('div', { class: 'relative' }, h(DropdownAction, {
        row,
      }))
    },
  },
  // {
  //   id: "actions",
  //   header: () => h('div', {}, ""),
  //   cell: ({ row }) => {
  //     return h("div", { class: "flex items-center justify-end gap-2" }, [
  //       h("button", { class: "bg-blue-100 text-blue-700 p-1 rounded hover:bg-blue-200" }, "✏️"),
  //       h("button", { class: "bg-red-100 text-red-700 p-1 rounded hover:bg-red-200" }, "🗑️")
  //     ])
  //   },
  // },
]